import { atom } from "recoil"
import { Key } from "../EnumKey"

const selectedCheckboxsAtom = atom({
  key: Key.SELECTEDCHECKBOXS,
  default: [] as string[]
})

export default selectedCheckboxsAtom